import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createSlots as _createSlots, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ddbfa594")

_pushScopeId("data-v-ddbfa594")
const _hoisted_1 = { class: "p-left-right-sm" }
const _hoisted_2 = { style: {"white-space":"nowrap"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" (")
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { style: {"color":"#8a8a8a"} }, "非厦门号码请在前面加0，比如 013899998888", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(") ")
const _hoisted_6 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_7 = { class: "p-left-right-sm" }
const _hoisted_8 = { class: "p-left-right-sm" }
const _hoisted_9 = { class: "p-left-right-sm" }
const _hoisted_10 = { class: "p-left-right-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock(_component_el_form, {
    "label-position": _ctx.$formLabelPosition,
    ref: "formEle",
    model: _ctx.basicData,
    rules: _ctx.rules,
    class: "set-page-form-width"
  }, {
    default: _withId(() => [
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextBuild,
        prop: "UnitID"
      }, {
        default: _withId(() => [
          _createVNode(_component_cus_select, {
            modelValue: _ctx.basicData.UnitID,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.basicData.UnitID = $event)),
            disabled: !!_ctx.id,
            width: "300px"
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.buildOptions, (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item,
                  value: item.key,
                  label: item.value
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextApt,
        prop: "RoomID"
      }, {
        default: _withId(() => [
          _createVNode(_component_cus_select, {
            modelValue: _ctx.basicData.RoomID,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.basicData.RoomID = $event)),
            disabled: !!_ctx.id,
            width: "300px"
          }, {
            default: _withId(() => [
              (_ctx.basicData.UnitID != '')
                ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.aptOptions, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item,
                      value: item.key,
                      label: item.value
                    }, null, 8, ["value", "label"]))
                  }), 128))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextAccountType
      }, {
        default: _withId(() => [
          _createVNode(_component_cus_select, {
            modelValue: _ctx.accountType,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.accountType = $event)),
            disabled: "",
            width: "300px"
          }, {
            default: _withId(() => [
              _createVNode(_component_cus_option, {
                value: "main",
                label: _ctx.$wordList.ProperAllTextMasterAccount
              }, null, 8, ["label"]),
              _createVNode(_component_cus_option, {
                value: "sub",
                label: _ctx.$wordList.ProperAllTextMemberAccount
              }, null, 8, ["label"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextFirstName,
        prop: "FirstName"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.FirstName,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.basicData.FirstName = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextLastName,
        prop: "LastName"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.LastName,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.basicData.LastName = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextEmail,
        prop: "Email"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.Email,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.basicData.Email = $event)),
            disabled: _ctx.basicData.IsMulti === 1
          }, null, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextCountryRegion,
        prop: "PhoneCode"
      }, {
        default: _withId(() => [
          _createVNode(_component_cus_select, {
            modelValue: _ctx.basicData.PhoneCode,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.basicData.PhoneCode = $event)),
            filter: "",
            style: {"width":"100%"},
            disabled: _ctx.isCNServer || _ctx.basicData.IsMulti === 1
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getPhoneCodeOps(), (item) => {
                return (_openBlock(), _createBlock(_component_cus_option, {
                  key: item,
                  value: item.value,
                  label: item.label
                }, null, 8, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_el_form_item, {
        label: _ctx.$wordList.ProperAllTextMobileNumber,
        prop: "MobileNumber"
      }, {
        default: _withId(() => [
          _createVNode(_component_el_input, {
            modelValue: _ctx.basicData.MobileNumber,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.basicData.MobileNumber = $event)),
            disabled: _ctx.basicData.IsMulti === 1,
            onInput: _ctx.limitMobileNumberType
          }, _createSlots({ _: 2 }, [
            (_ctx.basicData.PhoneCode)
              ? {
                  name: "prepend",
                  fn: _withId(() => [
                    _createVNode("span", _hoisted_1, " +" + _toDisplayString(_ctx.basicData.PhoneCode), 1)
                  ])
                }
              : undefined
          ]), 1032, ["modelValue", "disabled", "onInput"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.isEnableLiadline == 1)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.accountType == 'main')
              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_el_form_item, null, {
                    default: _withId(() => [
                      _createVNode("label", _hoisted_2, [
                        _createTextVNode(_toDisplayString(_ctx.$wordList.FirstLandline) + " ", 1),
                        (_ctx.isCNServer)
                          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                              _hoisted_3,
                              _hoisted_4,
                              _hoisted_5
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_6,
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.basicData.Phone,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.basicData.Phone = $event))
                      }, _createSlots({ _: 2 }, [
                        (_ctx.basicData.PhoneCode)
                          ? {
                              name: "prepend",
                              fn: _withId(() => [
                                _createVNode("span", _hoisted_7, " +" + _toDisplayString(_ctx.basicData.PhoneCode), 1)
                              ])
                            }
                          : undefined
                      ]), 1032, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$wordList.SecondLandline
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.basicData.Phone2,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.basicData.Phone2 = $event))
                      }, _createSlots({ _: 2 }, [
                        (_ctx.basicData.PhoneCode)
                          ? {
                              name: "prepend",
                              fn: _withId(() => [
                                _createVNode("span", _hoisted_8, " +" + _toDisplayString(_ctx.basicData.PhoneCode), 1)
                              ])
                            }
                          : undefined
                      ]), 1032, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$wordList.ThirdLandline
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.basicData.Phone3,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.basicData.Phone3 = $event))
                      }, _createSlots({ _: 2 }, [
                        (_ctx.basicData.PhoneCode)
                          ? {
                              name: "prepend",
                              fn: _withId(() => [
                                _createVNode("span", _hoisted_9, " +" + _toDisplayString(_ctx.basicData.PhoneCode), 1)
                              ])
                            }
                          : undefined
                      ]), 1032, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: _ctx.$wordList.LandlineNumber + (_ctx.isCNServer ? ' (非厦门号码请在前面加0，比如 013899998888) ' : '')
                }, {
                  default: _withId(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.basicData.Phone,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.basicData.Phone = $event))
                    }, _createSlots({ _: 2 }, [
                      (_ctx.basicData.PhoneCode)
                        ? {
                            name: "prepend",
                            fn: _withId(() => [
                              _createVNode("span", _hoisted_10, " +" + _toDisplayString(_ctx.basicData.PhoneCode), 1)
                            ])
                          }
                        : undefined
                    ]), 1032, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"]))
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["label-position", "model", "rules"]))
})